import React from 'react';
import { useTranslation } from 'Shared/Hooks/useTranslation';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';
import locales from '../../i18n/localeEs';

const translations = locales.es;

type EnrollmentButtonType = {
  courseType: string;
  customLabel?: string;
  canShowAccessPreview: boolean;
  enrollInCourse(): void;
  userIsPremiumMember?: boolean | null;
  canEnrollToCourseFreemium?: boolean;
};

const EnrollmentButton: React.FC<EnrollmentButtonType> = ({
  courseType,
  customLabel,
  canShowAccessPreview,
  enrollInCourse,
  userIsPremiumMember,
  canEnrollToCourseFreemium,
}) => {
  const { t } = useTranslation();

  const getLabel = () => {
    if (canEnrollToCourseFreemium && !userIsPremiumMember) {
      return `${t('TRY_COURSE', {
        defaultValue: translations.TEMPORAL_ACCESS,
      })}*`;
    }
    if (courseType === 'temporal-access' && !userIsPremiumMember) {
      return t('TEMPORAL_ACCESS', {
        defaultValue: translations.TEMPORAL_ACCESS,
      });
    }
    if (canShowAccessPreview) {
      return t('TRY_COURSE', {
        defaultValue: translations.TEMPORAL_ACCESS,
      });
    }
    if (courseType === 'membership') {
      return t('PREMIUM_ACCCES', {
        defaultValue: translations.PREMIUM_ACCCES,
      });
    }
    if (courseType === 'free') {
      return t('FREE_SUBSCRIPTION', {
        defaultValue: translations.PREMIUM_ACCCES,
      });
    }
    if (customLabel) {
      return customLabel;
    }
    return t('SUBSCRIBE_NOW', {
      defaultValue: translations.SUBSCRIBE_NOW,
    });
  };

  return <PrimaryButton onClick={enrollInCourse} full label={getLabel()} />;
};

export default EnrollmentButton;
